import React from 'react';
import Popover from '@material-ui/core/Popover';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import { makeStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import { getContextMenuState } from '../Reducers/App/Selectors';
import { useDispatch, useSelector } from 'react-redux';
import { setContextMenuState } from '../Reducers/App/Actions';
import { removeDoor } from '../Reducers/Configurator/Actions';
import { gray, white } from '../Screens/Colors';

const defaultTransformOrigin = {
  vertical: 'top',
  horizontal: 'center',
};

const useStyles = makeStyles(
  () => ({
    removeBtn: {
      backgroundColor: gray,
      color: white,
      '&:hover': {
        backgroundColor: gray,
        opacity: 0.7,
      }
    },
    removeIcon: {
      marginRight: 5
    }
  }),
  {
    name: 'ContextMenu',
  }
);

export const ContextMenu = () => {
  const classes = useStyles();
  const { open, top, left, target } = useSelector(getContextMenuState);
  const dispatch = useDispatch();
  const onClose = () => dispatch(setContextMenuState({ open: false, top: 0, left: 0 }));
  const onRemoveClick = () => {
    target.wall && dispatch(removeDoor(target.wall, target.position));
    onClose();
  };
  return (
    <Popover
      open={open}
      onClose={onClose}
      TransitionComponent={Fade}
      anchorReference="anchorPosition"
      anchorPosition={{
        top: 760,
        left,
      }}
      transformOrigin={defaultTransformOrigin}
      disableScrollLock
    >
      <Button className={classes.removeBtn} onClick={onRemoveClick}>
        <DeleteIcon className={classes.removeIcon} />
        {t('hintMessages.removeDoor')}
      </Button>
    </Popover>
  );
};

export default ContextMenu;
